module.exports = __webpack_public_path__ + "img/iphone13.77da5d09.svg";